import { ApprovalStatus } from 'core/creative/Creative';
import styles from './batchCreativeReviews.module.scss';
import classNames from 'classnames/bind';
import i18n from 'i18n';
import { useCallback, useMemo } from 'react';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { hasFuncs } from 'core/permission/PermissionDSL';
import { Permission } from 'core/auth/Permission';
import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';
import { faHandPointUp } from '@fortawesome/free-regular-svg-icons';
const cx = classNames.bind(styles);

export const BatchCreativeReviews: React.FC<{
  creativesData: {
    creativeId: number;
    approvalData: { state: ApprovalStatus, attr?: string[] },
  }[];
  reviewCreatives: (adx: string, ids: number[]) => void;
  className?: string;
}> = ({ creativesData, className, reviewCreatives }) => {

  const stateData = useMemo(() => {
    const approvalData = creativesData.reduce((acc, data) => {
      const state = data.approvalData.state;
      acc[state] = (acc[state] || 0) + 1;
      return acc;
    }, {});
    let stateDesc = i18n.t<string>('batchCreativeReview.labels.pending');
    let stateClass = styles.pending;
    if (approvalData[ApprovalStatus.APPROVED] === creativesData.length) {
      stateDesc = i18n.t<string>('batchCreativeReview.labels.approved');
      stateClass = styles.approved;
    } else if (approvalData[ApprovalStatus.DENIED] === creativesData.length) {
      stateDesc = i18n.t<string>('batchCreativeReview.labels.rejected');
      stateClass = styles.denied;
    } else if (approvalData[ApprovalStatus.APPROVED] > 0) {
      stateDesc = i18n.t<string>('batchCreativeReview.labels.partiallyApproved');
      stateClass = styles.partiallyApproved;
    }
    return {
      stateDesc,
      stateClass,
      showReviewBtn: approvalData[ApprovalStatus.DENIED] > 0
    };
  }, [creativesData]);

  const onReviewBtnClick = useCallback(() => {
    const creativeIds = creativesData
      .filter((data) => data.approvalData.state === ApprovalStatus.DENIED)
      .map((data) => data.creativeId);
    reviewCreatives('asiamax', creativeIds);
  }, [creativesData, reviewCreatives]);

  const mainClass = cx(styles.batchCreativeReviews, className);
  return (
    <div className={mainClass}>
      <span className={cx(styles.approvalContent, stateData.stateClass)}>
        {stateData.stateDesc}
      </span>
      {stateData.showReviewBtn && (
        <PermissionChecker
          permissionAware={hasFuncs(Permission.CREATIVE_WRITE)}
        >
          <IconWithTooltip
            className={styles.reviewBtn}
            onClick={onReviewBtnClick}
            icon={faHandPointUp}
            tooltipProps={{
              id: `creativeReviewBtn-${creativesData[0].creativeId}`,
              tooltip: i18n.t<string>('creativeReview.labels.reviewHint')
            }}
          />
        </PermissionChecker>
      )}
    </div>
  );
};
